import '.a{display:flex;}.ssr-plugin'
import '.bu{flex:1;}.ssr-plugin'
import { Card } from './Card'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Image } from '@app/components/core/image/Image'
import { InitiativeStatusRow } from './blocks/InitiativeStatusRow'
import { Text } from '@app/components/core/typography/Text'
import { Badge } from '@app/components/core/badge/Badge'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Tag } from '@app/components/core/tag/Tag'
import { ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DashboardListCardProps {
  avatar?: string
  image?: string
  location?: string
  status?: string
  title: string
  hasBadgeTitle?: boolean
  subtitle?: string
  description?: string
  tag?: string
  onClick?: () => void
  action?: ReactNode
}

export const DashboardListCard = ({
  avatar,
  image,
  location,
  status,
  title,
  hasBadgeTitle = false,
  subtitle,
  description,
  tag,
  onClick,
  action,
}: DashboardListCardProps) => {
  const isMobile = useMediaQuery()
  const renderAvatar = !!avatar || !image
  const renderSubtitle = !tag && (subtitle || description)

  const cardImage = renderAvatar ? (
    <Avatar
      size={'medium-large'}
      labelSource={title}
      image={avatar}
      variant="yellow"
      shape="square"
    />
  ) : (
    <Image
      src={image}
      resizeWidth={100}
      style={{
        flexShrink: 0,
        width: '6.25rem',
        height: '6.25rem',
        borderRadius: '1.25rem',
        objectFit: 'cover',
      }}
    />
  )

  return (
    <Card
      orientation="horizontal"
      border={false}
      image={cardImage}
      onClick={onClick}
      style={{
        flex: 1,
        alignItems: 'center',
        gap: 0,
      }}
      imageStyle={{
        width: 'auto',
        minWidth: 'auto',
        height: 'auto',
        padding: 0,
      }}
    >
      <div className="a bu"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: isMobile ? 'stretch' : 'space-between',
        }}
      >
        <Column
          gap="0.5rem"
          style={{
            width: '100%',
            marginBottom: isMobile && action ? '0.5rem' : '0',
          }}
        >
          {location && (
            <InitiativeStatusRow location={location} status={status} />
          )}
          <Row gap="0.5rem" style={{ alignItems: 'center' }}>
            <Title.H5
              style={{
                margin: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              {title}
            </Title.H5>
            {hasBadgeTitle && <Badge />}
          </Row>
          {tag && <Tag variant={'blueMuted'} size="small" label={tag} />}
          {renderSubtitle && (
            <Text.Small
              color={
                subtitle ? 'var(--primary-blue)' : 'var(--shades-blue-300)'
              }
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              {subtitle ?? description}
            </Text.Small>
          )}
        </Column>
        {action}
      </div>
    </Card>
  )
}
